import { useQueryClient } from '@tanstack/react-query';
import useAuthStore from '@/store/authStore';
import { useNavigate } from 'react-router';
import { clearAllFromLocalstorage, removeAuthStorage } from '@/utils/localstorage';

export const useLogout = () => {
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeAuthStorage(); // remove access & refresh token
    clearAuth(); // reset Zustand store
    useAuthStore.persist.clearStorage(); // clear persisted state
    queryClient.clear(); // clear React Query cache
    navigate('/'); // redirect to login
    clearAllFromLocalstorage();
  };

  return { handleLogout };
};
